import { UTMSourceEnum } from '../../enums';

export class UtmTagsDto {
	utmSource?: UTMSourceEnum;
	utmMedium?: string;
	utmCampaign?: string;
	utmContent?: string;
	utmAdset?: string;
	utmAdsetId?: string;
	utmOwner?: string;
}
